/**
 * Google Analytics 4 — debe coincidir con el Measurement ID en public/index.html.
 */
export const GA_MEASUREMENT_ID =
  process.env.VUE_APP_GA_MEASUREMENT_ID || 'G-70BXBJGQRG'

/**
 * Envía una vista de página a GA4 (SPA). Solo en producción.
 *
 * @param {string} pagePath - Ruta con query, p. ej. to.fullPath de Vue Router
 */
export function trackPageView(pagePath) {
  if (process.env.NODE_ENV !== 'production') {
    return
  }
  if (typeof window.gtag !== 'function' || !GA_MEASUREMENT_ID) {
    return
  }
  window.gtag('config', GA_MEASUREMENT_ID, { page_path: pagePath })
}
